<template>
  <div>
    <el-button type="primary" @click="addmaintenanceDialog=true">新建维修人员</el-button>
    <el-table v-loading="loadTable" :data="records" stripe @sort-change="sort_change">
      <el-table-column label="用户名" prop="nickName"/>
      <el-table-column label="账号" prop="account"/>
      <el-table-column :width="300" label="操作">
        <template #default="scope">
          <el-button size="mini" type="warning" @click="remove(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total"/>
    <addmaintenance-dialog :dialog="addmaintenanceDialog"/>
  </div>
</template>

<script>
import Page from "@/components/Page";
import pageMixin from "@/mixin/pageMixin";
import dialogMixin from "@/mixin/dialogMixin";
import timeMixin from "@/mixin/timeMixin";
import createdMixin from "@/mixin/createMixin";
import resDispose from "@/mixin/resDisposeMixin";
import searchMixin from "@/mixin/searchMixin";
import agentGetMantenanceMan from "@/api/user/maintenance-man-controler/agentGetMantenanceMan";
import AddmaintenanceDialog from "@/components/OperatorsManage/maintenance/addmaintenanceDialog";
import agentDelMantenanceMan from "@/api/user/maintenance-man-controler/agentDelMantenanceMan";

export default {
  name: "maintenanceList",
  components: {AddmaintenanceDialog, Page},
  mixins: [pageMixin, dialogMixin, timeMixin, createdMixin, resDispose, searchMixin],
  data() {
    return {
      addmaintenanceDialog: false,
      records: [],
      params: {
        pageNum: 1,
        size: 10,
        sortName: 'id',
        sortType: 'DESC',
      }
    }
  },
  methods: {
    sort_change(e) {
      this.params.sortName = e.prop
      this.params.sortType = e.order == 'descending' ? 'DESC' : 'ASC'
      if (e.order == null) {
        this.params.sortName = null
        this.params.sortType = null
      }
      console.log(this.params.sortName)
      // console.log(this.params.sortType)
      this.fetchData()
    },
    remove(id) {
      agentDelMantenanceMan({id: id}).then((res) => {
        this.resFetch({res});
      })
    },
    fetchData() {
      this.loadTable = true;
      this.params.pageNum = this.current;
      this.params.size = this.size;
      agentGetMantenanceMan(this.params).then(res => {
        this.total = res.data.total;
        this.records = res.data.records;
      }).finally(() => {
        this.loadTable = false;
      });
    },
  }
}
</script>
